<template>
    <kt-row style="margin-bottom: 50px">
        <div v-for="(account,index) in application.bank_accounts" v-bind:key="index" class="col-12">
            <hr v-if="index != 0" :id="'account_hr_tag'+index">
            <kt-row>
                <kt-col xs="6" sm="5" md="4" lg="3">
                    <p style="font-size: small;display: inline-block">
                        {{ $t('application.account_detail') }}{{ ' ' }}{{ $i18n.t('ordinal_numbers.' + [index + 1]) }}
                    </p>
                </kt-col>
                <kt-col xs="1" sm="2" md="4" lg="6">
                </kt-col>
                <kt-col xs="5" sm="5" md="4" lg="3"
                        v-if="current_user.id === application.user_id">
                    <kt-form-group>
                        <a @click="deleteBankAccount(index)"
                           :id="'delete_bank_account_btn'+index"
                           class="w-100 h-100 p-2 pt-3 btn-sm btn btn-label-danger btn-bold float-right">
                            <i class="la la-trash-o"></i>
                            {{ $t('btn.delete') }}
                        </a>
                    </kt-form-group>

                </kt-col>
            </kt-row>

            <kt-row style="margin-top: 20px">
                <kt-col xs="12" sm="6" md="6" lg="6">
                    <kt-form-group>
                        <kt-form-label for="first_name">
                            {{ $t("label.first_name") }}
                        </kt-form-label>
                        <kt-form-control
                            dir="rtl"
                            disabled
                            :name="'accounts.'+index +'.first_name'"
                            :id="'account_first_name'+index"
                            v-model="account.first_name"
                        ></kt-form-control>
                        <p :id="'first_name_error'+index"
                           style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6" md="6" lg="6">
                    <kt-form-group>
                        <kt-form-label for="last_name">
                            {{ $t("label.last_name") }}
                        </kt-form-label>
                        <kt-form-control
                            dir="rtl"
                            disabled
                            :name="'accounts.'+index +'.last_name'"
                            :id="'account_last_name'+index"
                            v-model="account.last_name"
                        ></kt-form-control>
                        <p :id="'last_name_error'+index"
                           style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6" md="6" lg="6">
                    <kt-form-group>
                        <kt-form-label for="account_bank_id">
                            {{ $t("label.bank_name") }}
                        </kt-form-label>
                        <kt-form-select
                            size="3"
                            disabled
                            class="form-control"
                            :name="'accounts.'+index +'.bank_id'"
                            :id="'account_bank_id'+index"
                            v-model="account.bank_id"
                        >
                            <option
                                v-bind:key="bank_id"
                                v-for="(bank_id, index) in banks"
                                v-bind:value="bank_id"
                            >
                                {{ $t("wallets.bank." + index) }}
                            </option>
                        </kt-form-select>
                        <p :id="'account_bank_id_error'+index"
                           style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6" md="6" lg="6">
                    <kt-form-group>
                        <kt-form-label for="account_account_number">
                            {{ $t("label.account_number") }}
                        </kt-form-label>
                        <kt-form-control
                            dir="ltr"
                            disabled
                            :name="'accounts.'+index +'.account_number'"
                            :id="'account_account_number'+index"
                            v-model="account.account_number"
                        ></kt-form-control>
                        <p :id="'account_account_number_error'+index"
                           style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6" md="6" lg="6">
                <kt-form-group>
                  <kt-form-label :for="'provider'+index">
                    {{ $t("label.provider") }}
                  </kt-form-label>
                  <kt-form-select
                      size="3"
                      class="form-control"
                      :name="'provider.'+index"
                      :id="'provider'+index"
                      v-model="account.provider"
                  >
                    <option
                        v-bind:key="provider"
                        v-for="provider in getServiceBankProvider(account.bank_id)"
                        v-bind:value="provider"
                    >
                      {{ openBankingProvidersStr.get(provider) }}
                    </option>
                  </kt-form-select>
                  <p :id="'account_bank_id_error'+index"
                     style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                </kt-form-group>
              </kt-col>
                <kt-col xs="12" sm="6" md="6" lg="6">
                    <kt-form-group>
                        <kt-form-label for="account_iban">
                            {{ $t("label.iban") }}
                        </kt-form-label>
                        <kt-form-control
                            style="direction: ltr"
                            disabled
                            class="form-control sheba"
                            :name="'accounts.'+index +'.iban'"
                            :id="'account_iban'+index"
                            v-model="account.iban"
                        ></kt-form-control>
                        <p :id="'account_iban_error'+index"
                           style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6" md="6" lg="6">
                    <kt-form-group>
                        <kt-form-label for="account_shahab_code">
                            {{ $t("open_banking.shahab_code") }}
                        </kt-form-label>
                        <kt-form-control
                            dir="ltr"
                            disabled
                            :name="'accounts.'+index +'.shahab_code'"
                            :id="'account_shahab_code'+index"
                            v-model="account.shahab_code"
                        ></kt-form-control>
                        <p :id="'shahab_code_error'+index"
                           style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6" md="6" lg="6" >
                    <kt-form-group>
                        <kt-form-label v-if="account.bank_id == bankId.saderat" for="account_username">
                            {{ $t("open_banking.shahin_username") }}
                        </kt-form-label>
                        <kt-form-label v-else for="account_username">
                            {{ $t("label.username") }}
                        </kt-form-label>
                        <kt-form-control
                            dir="ltr"
                            :name="'accounts.'+index +'.username'"
                            :id="'account_username'+index"
                            v-model="account.username"
                        ></kt-form-control>
                        <p :id="'username_error'+index"
                           style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6" md="6" lg="6">
                    <kt-form-group>
                        <kt-form-label v-if="account.bank_id == bankId.saderat" for="account_password">
                            {{ $t("open_banking.shahin_password") }}
                        </kt-form-label>
                        <kt-form-label v-else for="account_password">
                            {{ $t("label.password") }}
                        </kt-form-label>
                        <kt-form-control
                            dir="ltr"
                            :name="'accounts.'+index +'.password'"
                            :id="'account_password'+index"
                            v-model="account.password"
                        ></kt-form-control>
                        <p :id="'password_error'+index"
                           style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6" md="6" lg="6" v-if="account.provider === openBankingProviders.Keshavarzi">
                    <kt-form-group>
                        <kt-form-label :for="'rsa_key'+index">
                            {{ $t("label.rsa_key") }}
                        </kt-form-label>
                        <kt-form-control
                            dir="ltr"
                            :name="'rsa_key.'+index"
                            :id="'rsa_key'+index"
                            v-model="account.keshavarzi_rsa"
                        ></kt-form-control>
                        <p :id="'rsa_key'+index"
                           style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6" md="6" lg="6" v-if="account.provider === openBankingProviders.Keshavarzi">
                    <kt-form-group>
                        <kt-form-label :for="'keshavarzi_customer_code'+index">
                            {{ $t("label.customer_code") }}
                        </kt-form-label>
                        <kt-form-control
                            dir="ltr"
                            :name="'keshavarzi_customer_code.'+index"
                            :id="'keshavarzi_customer_code'+index"
                            v-model="account.keshavarzi_customer_code"
                        ></kt-form-control>
                        <p :id="'customer_code'+index"
                           style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6" md="6" lg="6" v-show="account.bank_id == bankId.saderat" >
                    <kt-form-group>
                        <kt-form-label for="account_suny_username">
                            {{ $t("open_banking.suny_username") }}
                        </kt-form-label>
                        <kt-form-control
                            dir="ltr"
                            :name="'accounts.'+index +'.suny_username'"
                            :id="'account_suny_username'+index"
                            v-model="account.suny_username"
                        ></kt-form-control>
                        <p :id="'suny_username_error'+index"
                           style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6" md="6" lg="6"  v-show="account.bank_id == bankId.saderat">
                    <kt-form-group>
                        <kt-form-label for="suny_account_password">
                            {{ $t("open_banking.suny_password") }}
                        </kt-form-label>
                        <kt-form-control
                            dir="ltr"
                            :name="'accounts.'+index +'.suny_password'"
                            :id="'account_suny_password'+index"
                            v-model="account.suny_password"
                        ></kt-form-control>
                        <p :id="'suny_password_error'+index"
                           style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6" md="6" lg="6"  v-show="account.bank_id == bankId.saderat" >
                    <kt-form-group>
                        <kt-form-label for="account_type">
                            {{ $t("open_banking.account_type") }}
                        </kt-form-label>
                        <kt-form-select
                            :name="'accounts.'+index +'.account_type'"
                            :id="'account_type'+index"
                            v-model="account.account_type"
                        >
                            <option :value="1">حقوقی سه طرفه وکالتی</option>
                            <option :value="2">حقیقی سه طرفه وکالتی</option>
                            <option :value="3">حقوقی دوطرفه</option>
                        </kt-form-select>
                        <p :id="'account_type'+index"
                           style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6" md="6" lg="6"
                        v-show="account.bank_id == bankId.saman">
                    <kt-form-group>
                        <kt-form-label for="cif">
                           cif
                        </kt-form-label>
                        <kt-form-control
                            dir="ltr"
                            :name="'accounts.'+index +'.cif'"
                            :id="'account_cif'+index"
                            v-model="account.cif"
                        ></kt-form-control>
                        <p :id="'cif_error'+index"
                           style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6" md="6" lg="6"
                        v-show="account.bank_id == bankId.saman">
                    <kt-form-group>
                        <kt-form-label for="channel">
                            channel
                        </kt-form-label>
                        <kt-form-control
                            dir="ltr"
                            :name="'accounts.'+index +'.channel'"
                            :id="'account_channel'+index"
                            v-model="account.channel"
                        ></kt-form-control>
                        <p :id="'channel_error'+index"
                           style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6" md="6" lg="6"
                        v-show="account.bank_id == bankId.saman">
                    <kt-form-group>
                        <kt-form-label for="secret_key">
                            secret_key
                        </kt-form-label>
                        <kt-form-control
                            dir="ltr"
                            :name="'accounts.'+index +'.secret_key'"
                            :id="'account_secret_key'+index"
                            v-model="account.secret_key"
                        ></kt-form-control>
                        <p :id="'secret_key_error'+index"
                           style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6" md="6" lg="6">
                    <kt-form-group>
                        <kt-form-label for="internal_limit">
                            {{ $t("application.internal_limit") }}
                        </kt-form-label>
                        <kt-form-control
                            dir="ltr"
                            type="number"
                            :name="'accounts.'+index +'.internal_limit'"
                            :id="'account_internal_limit'+index"
                            v-model="account.internal_limit"
                        ></kt-form-control>
                        <p :id="'internal_limit_error'+index"
                           style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6" md="6" lg="6">
                    <kt-form-group>
                        <kt-form-label for="paya_limit">
                            {{ $t("application.paya_limit") }}
                        </kt-form-label>
                        <kt-form-control
                            dir="ltr"
                            type="number"
                            :name="'accounts.'+index +'.paya_limit'"
                            :id="'account_paya_limit'+index"
                            v-model="account.paya_limit"
                        ></kt-form-control>
                        <p :id="'paya_limit_error'+index"
                           style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6" md="6" lg="6">
                    <kt-form-group>
                        <kt-form-label for="satna_limit">
                            {{ $t("application.satna_limit") }}
                        </kt-form-label>
                        <kt-form-control
                            dir="ltr"
                            type="number"
                            :name="'accounts.'+index +'.satna_limit'"
                            :id="'account_satna_limit'+index"
                            v-model="account.satna_limit"
                        ></kt-form-control>
                        <p :id="'satna_limit_error'+index"
                           style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6" md="6" lg="6" >
                    <kt-form-group>
                        <kt-form-label for="account_status">
                            {{ $t("label.status") }}
                        </kt-form-label>
                        <kt-form-select
                            size="3"
                            class="form-control"
                            :name="'accounts.'+index +'.status'"
                            :id="'account_status'+index"
                            v-model="account.status"
                        >
                            <option
                                v-bind:key="status"
                                v-for="status in bankAccessTokenStatus"
                                v-bind:value="status"
                            >
                                {{ bankAccessTokenStatusStr.get(status) }}
                            </option>
                        </kt-form-select>
                        <p :id="'status_error'+index"
                           style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                    </kt-form-group>
                </kt-col>
                <kt-col class="col-lg-4 col-sm-12" style="text-align: right">
                    <kt-form-action class="mt-4">
                        <kt-button
                            class="m-2 btn-wide"
                            size="md"
                            variant="success"
                            type="button"
                            v-bind:wide="true"
                            :id="'submit_change_bank_account_status_btn'+index"
                            @click="changeBankAccountStatus(index)"
                        >
                            {{ $t('btn.edit') }}
                        </kt-button>
                    </kt-form-action>
                </kt-col>
            </kt-row>
        </div>
        <div class="col-12" v-if="current_user.id === application.user_id">
            <kt-col xs="7" sm="5" md="4" lg="3" style="position: absolute;left:0;top: 20px">
                <div
                    type="button"
                    data-toggle="modal"
                    data-target="#add-bank-acoount-modal"
                    id="add_bank_account_btn"
                    class="kt-nav__link m-2 btn btn-outline-primary float-right"
                >
                    + {{ $t('application.add_new_account') }}
                </div>

            </kt-col>
        </div>
        <hr>

        <!--        Modal-->
        <div id="add-bank-acoount-modal" class="modal fade" role="dialog">
            <div class="modal-dialog" style="max-width: 700px">
                <!-- Modal content-->
                <div class="modal-content" id="bank-accounts-access-modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">
                            {{ $t('application.add_new_account') }}
                        </h4>
                        <button type="button" id="close_modal" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <form id="add_new_bank_account_form">
                            <kt-row style="margin-top: 20px">
                                <kt-col xs="12" sm="6" md="6" lg="6">
                                    <kt-form-group>
                                        <kt-form-label for="new_account_first_name">
                                            {{ $t("label.first_name") }}
                                        </kt-form-label>
                                        <kt-form-control
                                            dir="rtl"
                                            name="new_account_first_name"
                                            id="new_account_first_name"
                                            v-model="new_account.first_name"
                                        ></kt-form-control>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="6" lg="6">
                                    <kt-form-group>
                                        <kt-form-label for="new_account_last_name">
                                            {{ $t("label.last_name") }}
                                        </kt-form-label>
                                        <kt-form-control
                                            dir="rtl"
                                            name="new_account_last_name"
                                            id="new_account_last_name"
                                            v-model="new_account.last_name"
                                        ></kt-form-control>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="6" lg="6">
                                    <kt-form-group>
                                        <kt-form-label for="account_bank_id">
                                            {{ $t("label.bank_name") }}
                                        </kt-form-label>
                                        <kt-form-select
                                            size="3"
                                            class="form-control"
                                            name="new_account_bank_id"
                                            id="new_account_bank_id"
                                            v-model="new_account.bank_id"
                                        >
                                            <option
                                                v-bind:key="bank_id"
                                                v-for="(bank_id, index) in banks"
                                                v-bind:value="bank_id"
                                            >
                                                {{ $t("wallets.bank." + index) }}
                                            </option>
                                        </kt-form-select>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="6" lg="6">
                                    <kt-form-group>
                                        <kt-form-label for="new_account_account_number">
                                            {{ $t("label.account_number") }}
                                        </kt-form-label>
                                        <kt-form-control
                                            dir="ltr"
                                            name="new_account_account_number"
                                            id="new_account_account_number"
                                            v-model="new_account.account_number"
                                        ></kt-form-control>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="6" lg="6">
                                    <kt-form-group>
                                        <kt-form-label for="new_account_iban">
                                            {{ $t("label.iban") }}
                                        </kt-form-label>
                                        <kt-form-control
                                            style="direction: ltr"
                                            class="form-control sheba"
                                            name="new_account_iban"
                                            id="new_account_iban"
                                            v-model="new_account.iban"
                                        ></kt-form-control>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="6" lg="6">
                                    <kt-form-group>
                                        <kt-form-label for="new_account_shahab_code">
                                            {{ $t("open_banking.shahab_code") }}
                                        </kt-form-label>
                                        <kt-form-control
                                            dir="ltr"
                                            name="new_account_shahab_code"
                                            id="new_account_shahab_code"
                                            v-model="new_account.shahab_code"
                                        ></kt-form-control>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="6" lg="6">
                                    <kt-form-group>
                                        <kt-form-label for="internal_limit">
                                            {{ $t("application.internal_limit") }}
                                        </kt-form-label>
                                        <kt-form-control
                                            dir="ltr"
                                            name="internal_limit"
                                            id="internal_limit"
                                            v-model="new_account.internal_limit"
                                        ></kt-form-control>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="6" lg="6">
                                    <kt-form-group>
                                        <kt-form-label for="paya_limit">
                                            {{ $t("application.paya_limit") }}
                                        </kt-form-label>
                                        <kt-form-control
                                            dir="ltr"
                                            name="paya_limit"
                                            id="paya_limit"
                                            v-model="new_account.paya_limit"
                                        ></kt-form-control>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="6" lg="6">
                                    <kt-form-group>
                                        <kt-form-label for="satna_limit">
                                            {{ $t("application.satna_limit") }}
                                        </kt-form-label>
                                        <kt-form-control
                                            dir="ltr"
                                            name="satna_limit"
                                            id="satna_limit"
                                            v-model="new_account.satna_limit"
                                        ></kt-form-control>
                                    </kt-form-group>
                                </kt-col>
                            </kt-row>
                            <kt-form-action class="mt-4">
                                <kt-button
                                    class="m-2 btn-wide"
                                    size="lg"
                                    variant="success"
                                    type="button"
                                    v-bind:wide="true"
                                    id="add_new_bank_account_btn"
                                    @click="addNewBankAccount()"
                                >
                                    {{ $t('btn.add') }}
                                </kt-button>
                            </kt-form-action>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </kt-row>
</template>

<script>
import $ from "jquery";
import {i18n} from '@/plugins/i18n'
import toastr from "toastr";
import IranSheba from 'iran-sheba'
import Inputmask from "inputmask";
import {bankId} from "@/constants/bankId";
import {
  bankAccessTokenStatus,
  bankAccessTokenStatusStr,
  financialServices, openBankingProviders, openBankingProvidersStr, providerType, providerTypeStr
} from "@/constants/openBanking";
import {openBankingService} from "@/common/api.service";
import {KTApp} from "@/plugins/core/app";
import {mapGetters} from "vuex";


export default {
    props: {
        application: {
            required: true
        }
    },
    computed: {
      openBankingProviders() {
        return openBankingProviders
      },
      openBankingProvidersStr() {
        return openBankingProvidersStr
      },
      providerType() {
        return providerType
      },
      providerTypeStr() {
        return providerTypeStr
      },
        ...mapGetters('user', [
            'current_user'
        ]),
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        },
    },
    mounted() {
        this.afterDispatch()
        this.initShebaMask()
    },
    methods: {
      getServiceBankProvider(bank) {
        return this.application.providers[bank]
      },
        afterDispatch() {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: false,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })

            if (this.application.bank_accounts.length > 0){
                this.new_account.first_name = this.application.bank_accounts[0].first_name
                this.new_account.last_name = this.application.bank_accounts[0].last_name
            }
        },
        initShebaMask() {
            setTimeout(() => {
                Inputmask("IR 9999-9999-9999-9999-9999-9999").mask(document.querySelectorAll('.sheba'))
            }, 500)
        },
        addAccount() {
            this.accounts.push({
                first_name: '',
                last_name: '',
                bank_id: '',
                account_number: '',
                iban: '',
                shahab_code: '',
                internal_limit: '',
                paya_limit: '',
                satna_limit: '',
            });
            this.initShebaMask()
        },
        deleteBankAccount(index) {
            if (this.application.bank_accounts.length < 2) {
                for (var prop in this.financialServices) {
                    if (this.application.services[this.financialServices[prop]].is_selected) {
                        return this.toastr.error(i18n.t('application.message.cannot_delete_bank_account'))
                    }
                }
            }

            var result = confirm(i18n.t('application.message.remove_bank_account_alert'));
            if (!result) return;

            let btn = $('#delete_bank_account_btn' + index)
            btn.prop("disabled", true);

            btn.html(`<div class="d-flex justify-content-center align-items-center"><div class="px-2">لطفا صبر کنید</div><div class="spinner-border spinner-border-sm text-white" role="status"></div></div>`);

            openBankingService.deleteApplicationBankAccount(this.application.id, this.application.bank_accounts[index].id).then(response => {
                this.application.bank_accounts.splice(index, 1)
                this.toastr.success(response.data.message)
            }).catch(({response}) => {
                if (response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.toastr.error(response.data.message)
            }).finally(() => {
                    btn.prop("disabled", false);
                    btn.html(this.$t('btn.delete'));
                }
            )
        },
        addNewBankAccount() {
            let form = $('#add_new_bank_account_form')
            let btn = $('#add_new_bank_account_btn')

            form.validate({
                rules: {
                    new_account_bank_id: {
                        required: true,
                        number: true,
                    },
                    new_account_account_number: {
                        required: true,
                    },
                    new_account_iban: {
                        required: true,
                    },
                    new_account_first_name: {
                        required: true,
                    },
                    new_account_last_name: {
                        required: true,
                    },
                    new_account_shahab_code: {
                        number: true,
                    },
                }
            })
            if (!form.valid()) {
                return
            }

            let sheba = this.correctFormatSheba(this.new_account.iban)
            if (!this.IranSheba.isValid(sheba))
                return this.toastr.error(i18n.t('deposit.message.sheba_is_not_valid'))
            if (this.new_account.bank_id === this.bankId.saderat &&
                this.IranSheba.recognize(sheba).nickname !== 'saderat')
                return this.toastr.error(i18n.t('deposit.message.sheba_does_not_belong_to_saderat'))
            if (this.new_account.bank_id === this.bankId.keshavarzi &&
                this.IranSheba.recognize(sheba).nickname !== 'keshavarzi')
                return this.toastr.error(i18n.t('deposit.message.sheba_does_not_belong_to_keshavarzi'))
            if (this.new_account.bank_id === this.bankId.saman &&
                IranSheba.recognize(sheba).nickname !== 'saman')
                return this.toastr.error(i18n.t('deposit.message.sheba_does_not_belong_to_saman'))

            var all_ibans = [this.correctFormatSheba(this.new_account.iban)]
            let accounts = this.application.bank_accounts
            for (var prop in accounts) {
                accounts[prop].iban = this.correctFormatSheba(accounts[prop].iban)
                all_ibans.push(accounts[prop].iban)
            }
            var duplicates = all_ibans.filter((item, index) => all_ibans.indexOf(item) !== index);
            if (duplicates.length > 0)
                return this.toastr.error(i18n.t('application.message.duplicate_bank_account'))

            let params = {
                bank_id: this.new_account.bank_id,
                first_name: this.new_account.first_name,
                last_name: this.new_account.last_name,
                account_number: this.new_account.account_number,
                iban: this.correctFormatSheba(this.new_account.iban),
                shahab_code: this.new_account.shahab_code,
                internal_limit: this.new_account.internal_limit,
                paya_limit: this.new_account.paya_limit,
                satna_limit: this.new_account.satna_limit,
            }
            btn.prop("disabled", true);
            btn.html(`<div class="d-flex justify-content-center align-items-center"><div class="px-2">لطفا صبر کنید</div><div class="spinner-border spinner-border-sm text-white" role="status"></div></div>`);

            openBankingService.addApplicationBankAccount(params, this.application.id).then(response => {
                document.getElementById('close_modal').click()
                this.application.bank_accounts.push(response.data.data)
                this.initShebaMask()

                this.new_account = {
                    bank_id: '',
                    first_name: this.new_account.first_name = this.application.bank_accounts[0].first_name,
                    last_name: this.new_account.last_name = this.application.bank_accounts[0].last_name,
                    account_number: '',
                    iban: '',
                    shahab_code: '',
                    internal_limit: '',
                    paya_limit: '',
                    satna_limit: '',
                }

                this.toastr.success(response.data.message)
            }).catch(({response}) => {
                if (response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.toastr.error(response.data.message)
            }).finally(() => {
                    btn.prop("disabled", false);
                    btn.html(this.$t('btn.add'));
                }
            )

        },
        correctFormatSheba(sheba) {
            sheba = sheba+''
            sheba = sheba.split('-').join('')
            sheba = sheba.split('_').join('')
            return sheba.split(' ').join('')
        },
        changeBankAccountStatus(index) {
            let btn = $('#submit_change_bank_account_status_btn' + index)
            let has_error = false;

            if (!this.application.bank_accounts[index].status){
                document.getElementById('status_error' + index).innerText = i18n.t('application.message.field_required')
                document.getElementById('account_status' + index).style.borderColor = '#fd397a'
                has_error = true;
            }else {
                document.getElementById('status_error' + index).innerText = ''
                document.getElementById('account_status' + index).style.borderColor = '#e2e5ec'
            }
            if (this.application.bank_accounts[index].status == this.bankAccessTokenStatus.ACTIVE &&
                !this.application.bank_accounts[index].username &&
                (this.application.bank_accounts[index].bank_id !== this.bankId.saderat || this.application.bank_accounts[index].account_type === 3)){
                document.getElementById('username_error' + index).innerText = i18n.t('application.message.field_required')
                document.getElementById('account_username' + index).style.borderColor = '#fd397a'
                has_error = true;
            }else {
                document.getElementById('username_error' + index).innerText = ''
                document.getElementById('account_username' + index).style.borderColor = '#e2e5ec'
            }
            const bank_password = [this.bankId.keshavarzi, this.bankId.saman]
            if (this.application.bank_accounts[index].status == this.bankAccessTokenStatus.ACTIVE &&
                (bank_password.includes(this.application.bank_accounts[index].bank_id) || this.application.bank_accounts[index].account_type === 3) &&
                !this.application.bank_accounts[index].password){
                document.getElementById('password_error' + index).innerText = i18n.t('application.message.field_required')
                document.getElementById('account_password' + index).style.borderColor = '#fd397a'
                has_error = true;
            }else {
                document.getElementById('password_error' + index).innerText = ''
                document.getElementById('account_password' + index).style.borderColor = '#e2e5ec'
            }

            if (this.application.bank_accounts[index].status == this.bankAccessTokenStatus.ACTIVE &&
               this.application.bank_accounts[index].bank_id == this.bankId.saman &&
                !this.application.bank_accounts[index].cif){
                document.getElementById('cif_error' + index).innerText = i18n.t('application.message.field_required')
                document.getElementById('account_cif' + index).style.borderColor = '#fd397a'
                has_error = true;
            }else {
                document.getElementById('cif_error' + index).innerText = ''
                document.getElementById('account_cif' + index).style.borderColor = '#e2e5ec'
            }
            if (this.application.bank_accounts[index].status == this.bankAccessTokenStatus.ACTIVE &&
               this.application.bank_accounts[index].bank_id == this.bankId.saman &&
                !this.application.bank_accounts[index].channel){
                document.getElementById('channel_error' + index).innerText = i18n.t('application.message.field_required')
                document.getElementById('account_channel' + index).style.borderColor = '#fd397a'
                has_error = true;
            }else {
                document.getElementById('channel_error' + index).innerText = ''
                document.getElementById('account_channel' + index).style.borderColor = '#e2e5ec'
            }
            if (this.application.bank_accounts[index].status == this.bankAccessTokenStatus.ACTIVE &&
               this.application.bank_accounts[index].bank_id == this.bankId.saman &&
                !this.application.bank_accounts[index].secret_key){
                document.getElementById('secret_key_error' + index).innerText = i18n.t('application.message.field_required')
                document.getElementById('account_secret_key' + index).style.borderColor = '#fd397a'
                has_error = true;
            }else {
                document.getElementById('secret_key_error' + index).innerText = ''
                document.getElementById('account_secret_key' + index).style.borderColor = '#e2e5ec'
            }
            if (has_error)
                return ;

            btn.prop("disabled", true);
            btn.html(`<div class="d-flex justify-content-center align-items-center"><div class="px-2">لطفا صبر کنید</div><div class="spinner-border spinner-border-sm text-white" role="status"></div></div>`);

            var params = {
                status: this.application.bank_accounts[index].status,
                bank_account_id: this.application.bank_accounts[index].id,
                bank_id: this.application.bank_accounts[index].bank_id,
                password: this.application.bank_accounts[index].password,
                username: this.application.bank_accounts[index].username,
                cif: this.application.bank_accounts[index].cif,
                channel: this.application.bank_accounts[index].channel,
                secret_key: this.application.bank_accounts[index].secret_key,
                internal_limit: this.application.bank_accounts[index].internal_limit,
                paya_limit: this.application.bank_accounts[index].paya_limit,
                satna_limit: this.application.bank_accounts[index].satna_limit,
                provider: this.application.bank_accounts[index].provider,
                account_type: JSON.parse(this.application.bank_accounts[index].account_type)
            }
            if (this.bankId.saderat){
                params.suny_username = this.application.bank_accounts[index].suny_username;
                params.suny_password = this.application.bank_accounts[index].suny_password;
            }

            if (this.application.bank_accounts[index].provider === this.openBankingProviders.Keshavarzi && this.application.bank_accounts[index].bank_id === this.bankId.keshavarzi) {
              params.keshavarzi_rsa = this.application.bank_accounts[index].keshavarzi_rsa;
              params.keshavarzi_customer_code = this.application.bank_accounts[index].keshavarzi_customer_code;
            }

            openBankingService.changeApplicationBankAccountStatus(params, this.application.id).then(response => {
                this.toastr.success(response.data.message)
            }).catch(({response}) => {
                if (response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.toastr.error(response.data.message)
            }).finally(() => {
                    btn.prop("disabled", false);
                    btn.html(this.$t('btn.edit'));
                }
            )
        }
    },
    data() {
        return {
            banks: {
                keshavarzi: '016',
                saderat: '019',
                saman: '056',
            },
            new_account: {
                first_name: '',
                last_name: '',
                bank_id: '',
                account_number: '',
                iban: '',
                shahab_code: '',
            },
            bankId,
            IranSheba,
            bankAccessTokenStatus,
            bankAccessTokenStatusStr,
            financialServices
        }
    }
}
</script>

<style>

</style>